<template>
    <div>
        <div class="mx-7 my-4 form-input-group">
            <v-col class="pa-0" cols="5">
                <v-select
                    :items="timeFeatures"
                    v-model="timeFeatureSelect"
                    outlined
                    return-object
                    hide-details
                    dense
                    item-text="title"
                    item-color="secondary lighten-1"
                    color="secondary lighten-1"
                    @change="changeTimeFeatureSelect"
                ></v-select>
            </v-col>
            <label class="my-1">
                <slot name="labelSelect">
                    Ano dos dados no mapa:
                </slot>
            </label>
        </div>
        <v-row v-if="timeFeatures" class="ml-5 mr-6 my-4" align="center">
            <v-btn icon @click="changePlayer">
                <v-icon color="secondary lighten-1">{{playing ? 'mdi-pause-circle-outline' : 'mdi-play-circle-outline'}}</v-icon>
            </v-btn>
            <v-slider
                color="secondary lighten-1"
                v-model="currentTimeAtSlider"
                hide-details
                min="0"
                :max="endTimeFeature"
                step="1"
                :thumb-label="playing ? 'always' : ''"
            >
            <template v-slot:prepend>
                <span class="ml-1 mt-1">{{timeFeatures[endTimeFeature].title}}</span>
            </template>
            <template v-slot:thumb-label="{ value }">
                <v-chip label color="secondary lighten-1">
                    <strong>{{ timeFeatures[inverseTimeFeatureIndex(value)].title }}</strong>
                </v-chip>

            </template>
            <template v-slot:append>
                <span class="mt-1">{{timeFeatures[startTimeFeature].title}}</span>
            </template>
            </v-slider>
        </v-row>
    </div>
</template>

<script>
export default {
    name:'AnimationPlayer',
    props:{
        timeFeatures:{
            type: Array
        },
        dateFormat:{
            type: String,
            default: "YYYY"
        }
    },
    data:()=>({
        timeFeatureSelect: undefined,
        currentTimeAtSlider: undefined,
        playing: false,
        interval: undefined,
    }),
    watch:{
        currentTimeAtSlider(value){
            this.changeTimeFeature(value);
        },
        timeFeatures(value){
            if(value){
                this.initialize()
            }
        }
    },
    created(){
        this.initialize();
    },
    computed:{
        startTimeFeature(){
            return 0;
        },
        endTimeFeature(){
            return this.timeFeatures.length - 1;
        }
    },
    methods:{
        initialize(){
            this.currentTimeAtSlider = this.timeFeatures && this.timeFeatures.length ? this.timeFeatures.length - 1 : undefined;
            this.timeFeatureSelect =  this.timeFeatures && this.timeFeatures.length ? this.timeFeatures[0] : undefined;
        },
        changePlayer(){
            this.playing = !this.playing;
            if(this.playing){
                this.interval = setInterval(()=>{
                    if(this.currentTimeAtSlider == this.endTimeFeature){
                        this.currentTimeAtSlider = this.startTimeFeature;
                    }else{
                        this.currentTimeAtSlider += 1;
                    }

                }, 800)
            }else{
                this.clearAnimationInterval();
            }
        },
        changeTimeFeature(value){
            const timeFeature = this.timeFeatures[this.inverseTimeFeatureIndex(value)];
            this.timeFeatureSelect = timeFeature;
            this.$emit('changeTimeFeature', timeFeature);
        },
        changeTimeFeatureSelect(value){
            if(!this.playing){
                this.currentTimeAtSlider = this.inverseTimeFeatureIndex(this.timeFeatures.findIndex((item) => item.title == value.title));
            }
        },
        inverseTimeFeatureIndex(index){
            return (this.timeFeatures.length -1) - index;
        },
        clearAnimationInterval(){
            clearInterval(this.interval);
            this.playing = false;
        }
    }
}
</script>

<style scoped>
    label{
        order: -1;
        color: #ffffff;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
    }

    .v-input:focus-within + label{
        color: var(--v-secondary-lighten1);
    }

    .form-input-group{
        display: flex;
        flex-direction: column;
    }
</style>
